import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  sliderItems as sliderMock,
  productGroups as productMock,
  referenceLogos as referenceMock,
  testimonials as testimonialMock,
} from "../../mock";
import { ChevronLeft, ChevronRight, ArrowRight, User, Instagram } from "lucide-react";
import { fetchHomePageData } from "../../api";
import { useLanguage } from "../../contexts/LanguageContext";
import { t } from "../../i18n";
import useEmblaCarousel from "embla-carousel-react";

const SLIDE_INTERVAL = 6000;

// 60 yerel slider görseli - tam ekran hero için
const LOCAL_SLIDER = [
  { id: 1, title: "", image_url: "/slider/1.jpg" },
  { id: 2, title: "", image_url: "/slider/2.jpg" },
  { id: 3, title: "", image_url: "/slider/3.jpg" },
  { id: 4, title: "", image_url: "/slider/4.jpg" },
  { id: 5, title: "", image_url: "/slider/6.jpg" },
  { id: 6, title: "", image_url: "/slider/7.jpg" },
  { id: 7, title: "", image_url: "/slider/8.jpg" },
  { id: 8, title: "", image_url: "/slider/9.jpg" },
  { id: 9, title: "", image_url: "/slider/10.jpg" },
  { id: 10, title: "", image_url: "/slider/11.jpg" },
  { id: 11, title: "", image_url: "/slider/12.jpg" },
  { id: 12, title: "", image_url: "/slider/13.jpg" },
  { id: 13, title: "", image_url: "/slider/14.jpg" },
  { id: 14, title: "", image_url: "/slider/15.jpg" },
  { id: 15, title: "", image_url: "/slider/16.jpg" },
  { id: 16, title: "", image_url: "/slider/17.jpg" },
  { id: 17, title: "", image_url: "/slider/18.jpg" },
  { id: 18, title: "", image_url: "/slider/19.jpg" },
  { id: 19, title: "", image_url: "/slider/20.jpg" },
  { id: 20, title: "", image_url: "/slider/21.jpg" },
  { id: 21, title: "", image_url: "/slider/22.jpg" },
  { id: 22, title: "", image_url: "/slider/23.jpg" },
  { id: 23, title: "", image_url: "/slider/24.jpg" },
  { id: 24, title: "", image_url: "/slider/25.jpg" },
  { id: 25, title: "", image_url: "/slider/26.jpg" },
  { id: 26, title: "", image_url: "/slider/27.jpg" },
  { id: 27, title: "", image_url: "/slider/28.jpg" },
  { id: 28, title: "", image_url: "/slider/29.jpg" },
  { id: 29, title: "", image_url: "/slider/30.jpg" },
  { id: 30, title: "", image_url: "/slider/31.jpg" },
  { id: 31, title: "", image_url: "/slider/32.jpg" },
  { id: 32, title: "", image_url: "/slider/33.jpg" },
  { id: 33, title: "", image_url: "/slider/34.jpg" },
  { id: 34, title: "", image_url: "/slider/35.jpg" },
  { id: 35, title: "", image_url: "/slider/36.jpg" },
  { id: 36, title: "", image_url: "/slider/37.jpg" },
  { id: 37, title: "", image_url: "/slider/38.jpg" },
  { id: 38, title: "", image_url: "/slider/39.jpg" },
  { id: 39, title: "", image_url: "/slider/40.jpg" },
  { id: 40, title: "", image_url: "/slider/41.jpg" },
  { id: 41, title: "", image_url: "/slider/42.jpg" },
  { id: 42, title: "", image_url: "/slider/44.jpg" },
  { id: 43, title: "", image_url: "/slider/45.jpg" },
  { id: 44, title: "", image_url: "/slider/46.jpg" },
  { id: 45, title: "", image_url: "/slider/47.jpg" },
  { id: 46, title: "", image_url: "/slider/48.jpg" },
  { id: 47, title: "", image_url: "/slider/49.jpg" },
  { id: 48, title: "", image_url: "/slider/50.jpg" },
  { id: 49, title: "", image_url: "/slider/51.jpg" },
  { id: 50, title: "", image_url: "/slider/52.jpg" },
  { id: 51, title: "", image_url: "/slider/53.jpg" },
  { id: 52, title: "", image_url: "/slider/54.jpg" },
  { id: 53, title: "", image_url: "/slider/55.jpg" },
  { id: 54, title: "", image_url: "/slider/56.jpg" },
  { id: 55, title: "", image_url: "/slider/60.jpg" },
  { id: 56, title: "", image_url: "/slider/61.jpg" },
  { id: 57, title: "", image_url: "/slider/62.jpg" },
  { id: 58, title: "", image_url: "/slider/63.jpg" },
  { id: 59, title: "", image_url: "/slider/64.jpg" },
  { id: 60, title: "", image_url: "/slider/65.jpg" },
];

const INSTAGRAM_POSTS = [
  { id: 1, image: "/profinoks/instagram/post-1.jpg", alt: "Profinoks Açık Büfe ve Self Servis Hatları" },
  { id: 2, image: "/profinoks/instagram/post-2.jpg", alt: "Profinoks Şampiyon Filenin Sultanları" },
  { id: 3, image: "/profinoks/instagram/post-3.jpg", alt: "Profinoks Endüstriyel Mutfak Ekipmanları ve Şef Hattı" },
  { id: 4, image: "/profinoks/instagram/post-4.jpg", alt: "Profinoks Feriva Proje Uygulaması" },
];

const HomePage = () => {
  // 60 yerel görsel tam ekran slider - backend slider verisi ignore ediliyor
  const { lang } = useLanguage();
  const [sliderItems, setSliderItems] = useState(LOCAL_SLIDER);
  const [productGroups, setProductGroups] = useState(productMock);
  const [referenceLogos, setReferenceLogos] = useState(referenceMock);
  const [testimonials, setTestimonials] = useState(testimonialMock);

  const [activeSlide, setActiveSlide] = useState(0);
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    slidesToScroll: 1,
    containScroll: false
  });

  const [emblaRefT, emblaApiT] = useEmblaCarousel({
    loop: true,
    align: "start",
    slidesToScroll: 1, // Default to 1 for mobile
    breakpoints: {
      "(min-width: 1024px)": { slidesToScroll: 2 }
    }
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const scrollPrevT = useCallback(() => {
    if (emblaApiT) emblaApiT.scrollPrev();
  }, [emblaApiT]);

  const scrollNextT = useCallback(() => {
    if (emblaApiT) emblaApiT.scrollNext();
  }, [emblaApiT]);

  // Auto-scroll effect for references
  useEffect(() => {
    if (!emblaApi) return;
    const intervalId = setInterval(() => {
      emblaApi.scrollNext();
    }, 3000);
    return () => clearInterval(intervalId);
  }, [emblaApi]);

  useEffect(() => {
    let isMounted = true;

    fetchHomePageData()
      .then((data) => {
        if (!isMounted) return;
        // Slider artık 60 yerel görselle sabit - API slider ignore ediliyor (tam ekran isteği)

        // Primary source of truth for product groups is mock.js to maintain localized image paths and slugs
        // API data for groups is ignored for now to prevent broken image links shown on the home page


        if (data?.references?.length)
          setReferenceLogos(data.references.map((r) => r.image_url));
        if (data?.testimonials?.length) setTestimonials(data.testimonials);
      })
      .catch((err) => {
        // Fail silently and keep mock data
        console.error("Failed to fetch home page data", err);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prev) =>
        sliderItems.length ? (prev + 1) % sliderItems.length : prev
      );
    }, SLIDE_INTERVAL);

    return () => clearInterval(timer);
  }, [sliderItems.length]);

  useEffect(() => {
    const tTimer = setInterval(() => {
      setActiveTestimonial((prev) =>
        testimonials.length ? (prev + 1) % testimonials.length : prev
      );
    }, 9000);
    return () => clearInterval(tTimer);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setActiveTestimonial((prev) =>
      testimonials.length ? (prev + 1) % testimonials.length : prev
    );
  };

  const prevTestimonial = () => {
    setActiveTestimonial((prev) =>
      !testimonials.length ? prev : prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <div className="bg-background text-foreground">
      {/* Hero slider - viewport yüksekliğine tam sığacak şekilde */}
      <div className="w-full bg-[#121212] flex justify-center overflow-hidden">
        <section className="relative w-full max-w-[1900px] mx-auto h-[100dvh]">
          <div className="relative h-full w-full overflow-hidden">
            {sliderItems.map((slide, index) => (
              <div
                key={slide.id}
                className={[
                  "absolute inset-0 transition-opacity duration-700",
                  index === activeSlide ? "opacity-100" : "opacity-0",
                ].join(" ")}
              >
                <img
                  src={slide.image_url || slide.imageUrl}
                  alt={slide.title || `Slide ${index + 1}`}
                  className="h-full w-full object-cover object-center"
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  fetchPriority={index === 0 ? "high" : "low"}
                />
                <div className="absolute inset-0 bg-black/20" />
              </div>
            ))}

            {/* Slider controls */}
            <div className="pointer-events-none absolute inset-0 flex items-center justify-between px-6">
              <button
                type="button"
                className="pointer-events-auto inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/40 bg-black/40 text-white shadow-sm transition-colors hover:bg-black/80"
                onClick={() =>
                  setActiveSlide((prev) =>
                    !sliderItems.length
                      ? prev
                      : prev === 0
                        ? sliderItems.length - 1
                        : prev - 1
                  )
                }
              >
                <ChevronLeft className="h-4 w-4" />
              </button>
              <button
                type="button"
                className="pointer-events-auto inline-flex h-9 w-9 items-center justify-center rounded-full border border-white/40 bg-black/40 text-white shadow-sm transition-colors hover:bg-black/80"
                onClick={() =>
                  setActiveSlide((prev) =>
                    sliderItems.length ? (prev + 1) % sliderItems.length : prev
                  )
                }
              >
                <ChevronRight className="h-4 w-4" />
              </button>
            </div>

            <div className="absolute bottom-8 left-1/2 flex max-w-[92vw] -translate-x-1/2 flex-wrap justify-center gap-1.5 px-2">
              {sliderItems.map((slide, index) => (
                <button
                  key={slide.id}
                  type="button"
                  onClick={() => setActiveSlide(index)}
                  className={[
                    "h-1.5 rounded-full transition-all duration-300",
                    index === activeSlide
                      ? "w-6 bg-white"
                      : "w-1.5 bg-white/45 hover:bg-white/70",
                  ].join(" ")}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </section>
      </div>

      {/* Product groups */}
      <section className="bg-white py-8 sm:py-10 md:py-12 border-t border-black/5">
        <div className="w-full max-w-[1900px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6 sm:mb-8">
            <h2 className="text-2xl md:text-3xl font-semibold tracking-[0.16em] text-foreground uppercase flex items-center justify-center">
              <span className="bg-black/5 px-6 py-2 border-b-2 border-primary">
                {t(lang, "productGroups.heading")}
              </span>
            </h2>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {productGroups.map((group) => (
              <Link
                key={group.id}
                to={`/products/${group.slug}`}
                className="group relative block aspect-square w-full overflow-hidden bg-white rounded-lg border border-gray-100 shadow-[0_3px_10px_rgb(0,0,0,0.06)] hover:shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all duration-300"
              >
                <img
                  src={group.imageUrl}
                  alt={group[`title_${lang}`]}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-black/60 backdrop-blur-[2px] py-3 text-center border-t border-white/10 transition-colors group-hover:bg-primary/90">
                  <h3 className="text-[12px] font-bold tracking-widest text-white uppercase px-2 line-clamp-1">
                    {group[`title_${lang}`]}
                  </h3>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram posts section */}
      <section className="bg-[#fcfcfc] py-8 sm:py-10 md:py-12 border-t border-black/5">
        <div className="w-full max-w-[1900px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-6 sm:mb-8 gap-3">
            <div>
              <a
                href="https://www.instagram.com/profinoks/"
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-2.5 text-xl sm:text-2xl font-bold tracking-tight text-gray-900 hover:text-primary transition-colors"
              >
                <Instagram className="w-6 h-6 text-primary transition-transform group-hover:scale-110" />
                <span>{lang === "en" ? "Our Instagram Posts" : "İnstagram paylaşımlarımız"}</span>
              </a>
              <p className="text-xs sm:text-sm text-gray-500 mt-0.5">
                @profinoks
              </p>
            </div>
            <a
              href="https://www.instagram.com/profinoks/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs sm:text-sm font-semibold text-primary hover:underline group"
            >
              <span>{lang === "en" ? "Follow Us on Instagram" : "Bizi Instagram'da Takip Edin"}</span>
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            {INSTAGRAM_POSTS.map((post) => (
              <a
                key={post.id}
                href="https://www.instagram.com/profinoks/"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-square w-full overflow-hidden rounded-lg bg-gray-100 shadow-[0_2px_8px_rgba(0,0,0,0.06)] hover:shadow-[0_8px_24px_rgba(0,0,0,0.14)] transition-all duration-300"
              >
                <img
                  src={post.image}
                  alt={post.alt}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/35 transition-colors duration-300 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 text-primary flex items-center justify-center opacity-0 group-hover:opacity-100 transform scale-75 group-hover:scale-100 transition-all duration-300 shadow-lg">
                    <Instagram className="w-6 h-6" />
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* References logos */}
      <section className="bg-white py-10 md:py-14 w-full max-w-none overflow-hidden">
        <div className="w-full">
          <div className="mx-auto max-w-6xl px-4">
            <div className="flex flex-col items-start md:flex-row md:items-center md:justify-between">
              <div>
                <Link
                  to="/references"
                  className="text-lg font-semibold tracking-[0.22em] text-foreground hover:text-primary"
                >
                  {t(lang, "references.heading")}
                </Link>
                <hr className="mt-2 h-px w-16 border-none bg-primary" />
              </div>
              <p className="mt-3 text-sm text-muted-foreground md:mt-0">
                {t(lang, "references.tagline")}
              </p>
            </div>
          </div>

          <div className="relative mt-8 group">
            {/* Horizontal Lines - Now Full Width */}
            <div className="absolute -top-6 left-0 right-0 h-px bg-black/10" />
            <div className="absolute -bottom-6 left-0 right-0 h-px bg-black/10" />

            {/* Navigation Arrows - Positioned at viewport edges */}
            <div className="absolute left-4 top-1/2 -translate-y-1/2 z-20">
              <button
                onClick={scrollPrev}
                className="text-primary hover:scale-110 transition-transform bg-white/50 backdrop-blur-sm rounded-full p-2"
                aria-label="Previous references"
              >
                <ChevronLeft size={48} strokeWidth={3} />
              </button>
            </div>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 z-20">
              <button
                onClick={scrollNext}
                className="text-primary hover:scale-110 transition-transform bg-white/50 backdrop-blur-sm rounded-full p-2"
                aria-label="Next references"
              >
                <ChevronRight size={48} strokeWidth={3} />
              </button>
            </div>

            <div className="overflow-hidden cursor-grab active:cursor-grabbing" ref={emblaRef}>
              <div className="flex">
                {referenceLogos.map((logo, index) => (
                  <div
                    key={`${logo}-${index}`}
                    className="flex-[0_0_auto] px-5 sm:px-10"
                  >
                    <div className="flex h-32 w-64 items-center justify-center bg-white">
                      <img
                        src={logo.image_url || logo}
                        alt="Reference logo"
                        className="max-h-28 max-w-[220px] object-contain transition-opacity opacity-80 hover:opacity-100"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Customer testimonials */}
      <section className="bg-white pb-20 pt-10 border-t border-black/5 w-full max-w-none overflow-hidden">
        <div className="w-full">
          <div className="mx-auto max-w-6xl px-4">
            <div className="mb-12 flex flex-col items-center justify-center text-center">
              <h2 className="text-xl md:text-2xl font-bold tracking-[0.2em] text-foreground uppercase">
                {t(lang, "testimonials.heading")}
              </h2>
              <div className="mt-4 h-1 w-16 bg-primary" />
            </div>
          </div>

          <div className="relative group">
            {/* Navigation Arrows - Extreme edges */}
            <div className="absolute left-4 top-1/2 -translate-y-1/2 z-20">
              <button
                onClick={scrollPrevT}
                className="text-primary hover:scale-110 transition-transform bg-white/50 backdrop-blur-sm rounded-full p-2"
                aria-label="Previous testimonials"
              >
                <ChevronLeft size={48} strokeWidth={3} />
              </button>
            </div>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 z-20">
              <button
                onClick={scrollNextT}
                className="text-primary hover:scale-110 transition-transform bg-white/50 backdrop-blur-sm rounded-full p-2"
                aria-label="Next testimonials"
              >
                <ChevronRight size={48} strokeWidth={3} />
              </button>
            </div>

            <div className="overflow-hidden" ref={emblaRefT}>
              <div className="flex">
                {testimonials.map((item, index) => (
                  <div
                    key={item.id}
                    className="flex-[0_0_100%] lg:flex-[0_0_50%] px-4 lg:px-6"
                  >
                    <div className="flex flex-col md:flex-row h-full border-t border-b border-black/5 md:border-none shadow-sm">
                      {/* Left Side: Image (Narrower - 1/3) */}
                      <div className="w-full md:w-1/3 aspect-[4/3] md:aspect-auto relative overflow-hidden bg-[#E5E7EB]">
                        {item.image_url ? (
                          <img
                            src={item.image_url}
                            alt={item.person}
                            className="h-full w-full object-cover"
                          />
                        ) : (
                          <div className="h-full w-full flex items-center justify-center">
                            <User size={64} className="text-primary/10" strokeWidth={1} />
                          </div>
                        )}
                        <div className="absolute inset-0 bg-black/5" />
                      </div>

                      {/* Right Side: Text (Wider - 2/3) (Maroon BG) */}
                      <div className="w-full md:w-2/3 bg-primary p-6 lg:p-8 text-left flex flex-col justify-center min-h-[220px]">
                        <div>
                          <div className="text-[13px] lg:text-[14px] font-bold text-white tracking-[0.18em] uppercase mb-1">
                            {item.person}
                          </div>
                          <div className="text-[11px] lg:text-[12px] text-white/70 uppercase tracking-[0.15em] mb-4">
                            {item[`role_${lang}`]}
                          </div>
                          <p className="text-[12px] lg:text-[13px] text-white/90 leading-relaxed font-light italic border-l-2 border-white/20 pl-4">
                            "{item[`quote_${lang}`]}"
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default HomePage;
